export const PRELOADERS = [
  { id: "bag", name: "Shopping bag", blurb: "A product drops into a bag" },
  { id: "cart", name: "Cart", blurb: "A cart rolls into the shop" },
  { id: "barcode", name: "Barcode scan", blurb: "A line scans a product code" },
  { id: "gift", name: "Gift box", blurb: "A lid lifts off a gift" },
  { id: "shutter", name: "Store shutter", blurb: "A shutter rises on the shop" },
  { id: "none", name: "No preloader", blurb: "A blank screen until the store is ready" },
];

const IDS = new Set(PRELOADERS.map((p) => p.id));

export function normalizePreloader(value) {
  const id = String(value || "").trim().toLowerCase();
  return IDS.has(id) ? id : "barcode";
}
